<div class="resume-close-container">
  <a (click)="closeResumeDialog()">
    <i class="fas fa-times"></i></a>
</div>

<form class="resume-share-link-container" (ngSubmit)="closeResumeDialog()">

  <i class="fal fa-link"></i>

  <h3 transloco="resume.shareLink.title">Share Via Link</h3>

  <p *ngIf="!showResumeShareModal" transloco="portfolio.modal.shareLink.summary" class="resume-share-details" id="portfolio-share-details"></p>
  <p *ngIf="showResumeShareModal" transloco="resume.modal.shareLink.summary" class="resume-share-details" id="resume-share-details"></p>

  <div class="resume-share-link-view">
    <label class="successful-copy" transloco="resume.shareLink.copied">Copied to Clipboard</label>
    <div class="resume-share-link-wrapper">
      <aero-input type="text" [id]="'share-link'" [required]="false" [readonly]="true" name="share-link"
        label="{{ 'resume.shareLink.label' | transloco }}" [ngModel]="getShareLink()"></aero-input>

      <button class="resume-clipboard-container bulb-clipboard" id="resume-clipboard-container" type="button"
        attr.aria-label="{{ 'resume.shareLink.copyToClipboard' | transloco }}" (click)="copyShareLink()">
        <i class="far fa-clipboard" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <aero-button [aeroStyle]="buttonStyle" [size]="buttonSize" label="{{ 'resume.modal.shareLink.new' | transloco }}"
    (onClick)="regenerateShareLink()" class="resume-new-link"></aero-button>

  <div class="resume-dialog-btn-container">
    <aero-button label="{{ 'doneButton' | transloco }}" (onClick)="closeResumeDialog()">
    </aero-button>
  </div>
</form>
